import * as React from "react"
import { DayPicker } from "react-day-picker"
import { ChevronLeft, ChevronRight } from "lucide-react"

import { cn } from "../../lib/utils"

// Design-system Calendar — wraps react-day-picker v9 with full token-driven
// styling. We intentionally do NOT import "react-day-picker/style.css" because
// the library's defaults (rounded radius, accent color, font sizes, focus
// rings) override our shadcn tokens and produce the off-system look users
// keep flagging. Every DayPicker slot below uses cn-* / token classes so
// the calendar matches Card / Button / Badge density throughout the app.
function Calendar({
  className,
  classNames,
  components,
  showOutsideDays = true,
  ...props
}: React.ComponentProps<typeof DayPicker>) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn("cn-calendar", className)}
      classNames={{
        root: "rdp-root",
        months: "cn-calendar-months",
        month: "cn-calendar-month",
        month_caption: "cn-calendar-caption",
        caption_label: "cn-calendar-caption-label",
        dropdowns: "cn-calendar-dropdowns",
        dropdown_root: "cn-calendar-dropdown-root",
        dropdown: "cn-calendar-dropdown",
        months_dropdown: "cn-calendar-dropdown cn-calendar-months-dropdown",
        years_dropdown: "cn-calendar-dropdown cn-calendar-years-dropdown",
        nav: "cn-calendar-nav",
        button_previous: "cn-calendar-nav-button cn-calendar-nav-button-previous",
        button_next: "cn-calendar-nav-button cn-calendar-nav-button-next",
        month_grid: "cn-calendar-month-grid",
        weekdays: "cn-calendar-weekdays",
        weekday: "cn-calendar-weekday",
        week: "cn-calendar-week",
        day: "cn-calendar-day",
        day_button: "cn-calendar-day-button",
        selected: "cn-calendar-day-selected",
        today: "cn-calendar-day-today",
        outside: "cn-calendar-day-outside",
        disabled: "cn-calendar-day-disabled",
        range_start: "cn-calendar-day-range-start",
        range_end: "cn-calendar-day-range-end",
        range_middle: "cn-calendar-day-range-middle",
        hidden: "cn-calendar-day-hidden",
        ...classNames,
      }}
      components={{
        Chevron: ({ orientation }) => {
          const Icon = orientation === "left" ? ChevronLeft : ChevronRight
          return <Icon className="cn-calendar-nav-icon" />
        },
        ...components,
      }}
      {...props}
    />
  )
}

Calendar.displayName = "Calendar"

export { Calendar }
